module.exports = __webpack_public_path__ + "img/Slovakia.d0d69704.png";